import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "utils/axiosInstance";
import dayjs from "dayjs";
import { Grid, TextField } from "@mui/material";
import { useState } from "react";
import GKCommonPagination from "components/CommonPagination"; // Import your pagination component

const EmployeeTable = () => {
  const [filters, setFilters] = useState({
    search: "",
    paginationData: {
      skip: 0,
      page: 0,
      take: 25,
    },
  });

  const requestBody = {
    take: filters?.paginationData?.take,
    skip: filters?.paginationData?.skip,
    search: filters?.search || "",
  };

  const { data: employeeList, isFetching } = useQuery({
    queryKey: ["DASHBOARD_EMPLOYEE_TABLE", requestBody],
    queryFn: () =>
      axiosInstance.get(`/super_admin/employees/`, { params: requestBody }),
    staleTime: 24 * 60 * 60 * 1000, // 1 day
    onError: (err) => {
      // setShowAlert({
      //   type: "error",
      //   show: true,
      //   message: err?.response?.data?.message || "Something went wrong",
      // });
    },
  });

  const columns = [
    {
      headerName: "Employee Name",
      field: "name",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      valueGetter: (row) => row || "-",
    },
    {
      headerName: "Company Name",
      field: "companyName",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      valueGetter: (row) => row || "-",
    },
    {
      headerName: "Phone Number",
      field: "phone",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
      valueGetter: (row) => row || "-",
    },
    {
      headerName: "Created on",
      field: "createdOn",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => dayjs(params?.value).format("DD MMM YYYY"),
      valueGetter: (row) => row || "N/A",
    },
  ];

  const CustomPagination = () => {
    return (
      <GKCommonPagination
        totalCount={employeeList?.data?.totalCount || 0}
        page={filters?.paginationData.page}
        onPageChange={(newPage) => {
          setFilters({
            ...filters,
            paginationData: {
              ...filters.paginationData,
              page: newPage,
              skip: newPage * filters?.paginationData.take,
            },
          });
        }}
        take={filters?.paginationData.take}
        handleRowChange={(event) => {
          setFilters({
            ...filters,
            paginationData: {
              ...filters.paginationData,
              take: event.target.value,
            },
          });
        }}
      />
    );
  };

  const handleSearchChange = (event) => {
    setFilters({
      ...filters,
      search: event.target.value,
      paginationData: {
        ...filters.paginationData,
        skip: 0,
        page: 0,
      },
    });
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} display={"flex"} justifyContent={"space-between"}>
        <TextField
          sx={{ minWidth: "200px" }}
          variant="outlined"
          size="small"
          placeholder="Search Employee"
          value={filters.search}
          onChange={handleSearchChange}
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          autoHeight
          loading={isFetching}
          columns={columns}
          rows={employeeList?.data?.data || []}
          sx={{ "--DataGrid-overlayHeight": "600px" }}
          pageSize={filters.paginationData.take}
          rowCount={employeeList?.data.totalCount}
          paginationMode="server"
          slots={{
            footer: CustomPagination,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default EmployeeTable;
